/**
 * @date: 12/17/20
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2020 MaxMD Corporation, All Rights Reserved.
 *
 */
import React, {useEffect, useState} from "react";
import makeStyles from '@mui/styles/makeStyles';
import {handleHttpResponse} from "../utils/http-helpers";
import ShowMessage from "../utils/show-message";
import {isMasterAdmin} from "../utils/portal-helper";
import Alert from '@mui/material/Alert';
import { Pagination } from '@mui/material';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import OrganizationSearchPanel from "./OrganizationSearchPanel";
import ShowOrganizationsAsList from "./ShowOrganizationsAsList";
import Container from "@mui/material/Container";
import {ApiUrl} from "../utils/portal-urls";

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    moduleLabel: {
        display: 'inline-block', padding: '4px 8px', paddingRight: 5
    }
}));
export default function OrganizationsHome (props){
    const classes = useStyles();
    const account = props.account;
    if (!isMasterAdmin(account.user)){
        window.location.href="/";
    }


    const [tableListLoading, setTableListLoading] = useState(false);
    const [queryLoading, setQueryLoading] = useState(false);
    const [query, setQuery] = useState("");
    const [refresh, setRefresh] = useState("");

    const [page, setPage] = useState(0);
    const [msg, setMsg] = useState({});
    const [pageResult, setPageResult] = useState(null);

    useEffect(() => {
        if (page > 0){
            console.log('query changed, reset page to 0', query);
            setPage(0);
        } else {
            console.log('query changed, useEffect fetch: ', query, page);
            fetchPage(query, page);
        }
    }, [query]);
    useEffect(() => {
        console.log('page changed or refresh, useEffect fetch: ', query, page);
        fetchPage(query, page);
    }, [page, refresh]);

    // useEffect( () => {
    //     fetchVerifiedDomain();
    // }, [refresh]);

    const fetchPage = async (query, page) => {
        setTableListLoading("Loading");
        // setLoading(true);
        const url = ApiUrl.Organization.query.getPath(query, page);
        console.log(`GET ${url}`, query);
        fetch(url)
            .then(handleHttpResponse)
            .catch( (err) => {
                console.error('failed to query organizations', err);
                setTableListLoading(false);
                // setLoading(false);
                if (err){
                    setMsg({error: err});
                }
            }).then ( (res) => {
            setTableListLoading(false);
            // setLoading(false);
            console.log('query organizations result', res);
            setPageResult(res);
        });
    }

    return (
        // <Container  className='orgs-home-wrapper'>
        <Container maxWidth="lg" className={classes.container}>
            <h3 className='title'> Organizations
                {/*<Button variant="text" color="primary" href={`/CreateCertificate`} >*/}
                {/*    <AddIcon /> New Certificate*/}
                {/*</Button>*/}
            </h3>
            <ShowMessage msg={msg} />
            <OrganizationSearchPanel onQueryStringChanged={(q) => setQuery(q)} onRefresh={(v) => setRefresh(v)} />
            <hr/>

            <div className='orgs-list-wrapper'>
                {pageResult && <Alert severity="info" icon={false} >
                    Found {pageResult.totalElements} organization(s).
                    {pageResult.totalPages > 1 && `Showing page ${pageResult.pageable.pageNumber + 1} (${pageResult.pageable.offset + 1} ... ${pageResult.pageable.offset + pageResult.pageable.pageSize})`}

                </Alert>}

                {pageResult && pageResult.totalPages > 1 && <Pagination style={{marginTop: 10}} page={page + 1} count={pageResult.totalPages} variant={"outlined"} color={"primary"}
                                                                        onChange={(e, newPage) => setPage(newPage - 1)} />}

                { pageResult && pageResult.content && pageResult.content.length > 0
                && <ShowOrganizationsAsList handleSelectOrgForm={props.handleSelectOrgForm} organizations={pageResult.content} size='large' account={account}/>
                }

                {pageResult && pageResult.totalPages > 1 && <Pagination style={{marginTop: 10}} page={page + 1} count={pageResult.totalPages} variant={"outlined"} color={"primary"}
                                                                        onChange={(e, newPage) => setPage(newPage - 1)} />}

            </div>
            {/*<CertificateList onLoadingChanged={(loading) => setTableListLoading(loading)}  query={queryString} page={0} refresh={refresh} />*/}

            <Backdrop className={classes.backdrop} open={tableListLoading || queryLoading ? true : false} >
                <CircularProgress color={"inherit"} />
                {tableListLoading && <> {tableListLoading} ... </>}
                {queryLoading && <> {queryLoading} ... </>}
            </Backdrop>

        </Container>
    );
}
